import { render } from "./FloatingMenuMobile.vue?vue&type=template&id=4c71930f&scoped=true"
import script from "./FloatingMenuMobile.vue?vue&type=script&lang=js"
export * from "./FloatingMenuMobile.vue?vue&type=script&lang=js"

import "./FloatingMenuMobile.vue?vue&type=style&index=0&id=4c71930f&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c71930f"]])

export default __exports__